import { useContext } from 'react'
import { ResetNativeAppContext } from './context'

export const useResetNativeApp = () => useContext(ResetNativeAppContext)
